Ext.define('SA.view.quickreport.drag.QuickReportFloatingColumn', {
    alias: 'quickreport.floating-column',

    constructor(els, initialLeft, visibleXBounds) {
        this.visibleXBounds = visibleXBounds;

        this.headerCell = clone(els.headerCell).addCls('sa-quick-report-floating-column-header-cell');
        this.bodyColumn = clone(els.bodyColumn).addCls('sa-quick-report-floating-column-body-column');

        this.setLeft(initialLeft);

        function clone(el) {
            return Ext.get(Ext.clone(el)).appendTo(el.parentElement);
        }
    },

    destroy() {
        Ext.destroyMembers(this, 'headerCell', 'bodyColumn', 'visibleXBounds');
    },

    distanceObscuredAtLeft() {
        var leftOffsetToDoc = this.getLeftOffsetToDoc();

        return Math.max(0, this.visibleXBounds.left - leftOffsetToDoc);
    },

    distanceObscuredAtRight() {
        var leftOffsetToDoc = this.getLeftOffsetToDoc(),
            width = this.headerCell.dom.offsetWidth;

        return Math.max(0, leftOffsetToDoc + width - this.visibleXBounds.right);
    },

    getLeftOffsetToDoc() {
        return this.headerCell.getOffsetsTo(document)[0];
    },

    setLeft(left) {
        this.headerCell.setLeft(left);
        this.bodyColumn.setLeft(left);
    }
});